import createAPI from "../axios";

const trainingAgreement = {
    trainingAgreement: {
        initCombo: config => createAPI('/trainingAgreement/trainingAgreement/initCombo', 'post', config),
        userList: config => createAPI('/trainingAgreement/trainingAgreement/userList', 'post', config),
        save: config => createAPI('/trainingAgreement/trainingAgreement/save', 'post', config),
        findCourseListByMajorId: config => createAPI('/trainingAgreement/trainingAgreement/findCourseListByMajorId', 'post', config),
        queryList: config => createAPI('/trainingAgreement/trainingAgreement/queryList', 'post', config),
        saveRec: config => createAPI('/trainingAgreement/trainingAgreement/saveRec', 'post', config),
        deletefile: config => createAPI('/trainingAgreement/trainingAgreement/deletefile', 'post', config),
        queryRscList: config => createAPI('/trainingAgreement/trainingAgreement/queryRscList', 'post', config),
        queryPxkc: config => createAPI('/trainingAgreement/trainingAgreement/queryPxkc', 'post', config),
        del: config => createAPI('/trainingAgreement/trainingAgreement/del', 'post', config),
        submit: config => createAPI('/trainingAgreement/trainingAgreement/submit', 'post', config),
        // 文档管理API
        saveDoc: config => createAPI('/trainingAgreement/trainingAgreement/saveDoc', 'post', config),
        queryOneDoc: config => createAPI('/trainingAgreement/trainingAgreement/queryOneDoc', 'get', config),
        queryAllDoc: config => createAPI('/trainingAgreement/trainingAgreement/queryAllDoc', 'get', config),
        deleteDocById: config => createAPI('/trainingAgreement/trainingAgreement/deleteDocById', 'get', config),
        saveDocRec: config => createAPI('/trainingAgreement/trainingAgreement/saveDocRec', 'post', config),
        deleteDocFile: config => createAPI('/trainingAgreement/trainingAgreement/deleteDocFile', 'get', config),
        queryDocFileById: config => createAPI('/trainingAgreement/trainingAgreement/queryDocFileById', 'get', config),
    }
}
export default trainingAgreement;



// WEBPACK FOOTER //
// ./src/api/modules/trainingAgreement.js